import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CitasService } from 'src/app/services/citas.service';

@Component({
  selector: 'resumenComponent',
  templateUrl: 'resumenFormulario.html',
})
export class ResumenComponent {


  ocupacionActual: any;
  horas: any;
  entidades: any;
  mediosConocer: any;

  entidad: any;
  hora: any;
  ocupacion: any;
  fecha: string;
  formulario: any;
  empresa: string;

  mensaje: string;
  
  proceso: boolean;

  constructor(
    public dialogRef: MatDialogRef<ResumenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private service: CitasService) {
    this.formulario = data.formulario;
    dialogRef.disableClose = true;
    this.getCatalogos(data)
    let a = [{ day: 'numeric' }, { month: 'short' }, { year: 'numeric' }];
    this.fecha = this.join(data.picker, a, '-');
    this.proceso = false;
  }

  async getCatalogos(data) {
    this.getHoras(data);
    try {
      const get = await this.service.getCatalogo();

      this.entidades = get.entidades;
      this.ocupacionActual = get.ocupacion;
      this.entidad = this.entidades.filter(e => e.id === data.entidad)[0];
      this.ocupacion = this.ocupacionActual.filter(o => o.id === data.ocupacionActual)[0];
      this.mediosConocer = get.medios;
    } catch (error) {
      console.log(error);
    }
  }
  async getHoras(data) {
    try {
      const get = await this.service.getHorarios(this.formulario.controls.picker.value);
      this.horas = get;
      if (this.horas.length === 0) {
        this.dialogRef.close('Le han  ganado el Horario');
      } else {
        this.hora = this.horas.filter(h => h.id === data.hora)[0];
        if(this.hora === undefined){
          this.dialogRef.close('Usted ya agendo en este horario');
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  onNoClick(): void {
    this.dialogRef.close("0");
  }

  async onClick() {
    //let horario = this.horas.filter(h => h.value === this.formulario.controls.hora.value)
    this.proceso = true;
    const hrs = this.hora.descripcion.split(" - ");
    let a = [{ year: 'numeric' }, { month: 'numeric' }, { day: 'numeric' }];
    let s = this.join(this.formulario.controls.picker.value, a, '-');
    const request = {
      encabezado: "CONOCER",
      ubicacion: "Videollamada",
      fechaInicio: `${s}T${hrs[0]}-05:00`,
      fechaFin: `${s}T${hrs[1]}-05:00`,
      email: this.formulario.controls.email.value,
      descripcion: this.formulario.controls.descripcion.value,
      nombre: this.formulario.controls.nombre.value,
      empresa: this.formulario.controls.empresa.value,
      ocupacion: this.formulario.controls.ocupacionActual.value,
      fecha: this.formulario.controls.picker.value,
      horario: this.formulario.controls.hora.value,
      entidad: this.formulario.controls.entidad.value,
      medios: this.formulario.controls.medios.value,
      telefono: this.data.telefono
    }
    try {
      const post = await this.service.createEvent(request);
      if (post.id === 1) {
        this.mensaje = `La solicitud de su cita fue enviada a ${this.data.email}`;
      } else {
        this.mensaje = "!Algo Salio mal!";
      }
      this.dialogRef.close(this.mensaje);
    } catch (error) {
      console.log(error);
    }
  }

  join(t, a, s) {
    function format(m) {
      let f = new Intl.DateTimeFormat('es', m);
      if (f.format(t).length >= 2) {
        return f.format(t);
      } else {
        return `0${f.format(t)}`
      }
    }
    return a.map(format).join(s);
  }

}